import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { TokenStorageService } from 'services/token/token-storage.service';
import { TokenService } from 'services/token/token.service';
import { DomainService } from 'services/domain/domain.service';
import { LoginStatusService } from 'services/token/login-status.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { switchMap, tap } from 'rxjs/operators';
import { Observable, of, throwError } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { LOGIN_STATUSES } from 'constants/auth.constants';
import { DEFAULT_PRODUCTION_DOMAIN_NAME } from '../../../global';

@UntilDestroy()
@Component({
  selector: 'cm-member-clicks-login',
  templateUrl: './member-clicks-login.component.html',
  styleUrls: ['../shared-styles/styles.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MemberClicksLoginComponent implements OnInit, OnDestroy {
  constructor(
    private tokenStorage: TokenStorageService,
    private tokenService: TokenService,
    private domainService: DomainService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private loginStatusService: LoginStatusService,
  ) {}

  ngOnInit() {
    const { code_name, memberClicksUserToken, enrollment_url } = this.activatedRoute.snapshot.queryParams;

    if (
      memberClicksUserToken &&
      this.domainService.getDomainNameFromToken(memberClicksUserToken) &&
      this.domainService.getDomainNameFromUrl() === DEFAULT_PRODUCTION_DOMAIN_NAME
    ) {
      this.domainService.changeDomain({ token: memberClicksUserToken });
      return;
    }

    if (memberClicksUserToken) {
      this.processLoginStatus(memberClicksUserToken, code_name, enrollment_url);
    }
  }

  ngOnDestroy() {}

  private processLoginStatus(memberClicksUserToken: string, loginStatus: LOGIN_STATUSES, enrollmentUrl: string) {
    this.loginStatusService
      .handleLoginError(loginStatus, true)
      .pipe(
        untilDestroyed(this),
        switchMap(({ success, acceptTerms }) => {
          this.tokenStorage.userToken = memberClicksUserToken;
          if (acceptTerms) {
            return this.tokenService.acceptTermsAndConditions().pipe(untilDestroyed(this));
          } else {
            return success ? of(null) : throwError('');
          }
        }),
        tap(() => this.loginStatusService.processLoginStatus(loginStatus)),
        switchMap(() => {
          if (enrollmentUrl) {
            return this.processSelfEnrollment(this.tokenStorage.userToken, enrollmentUrl);
          }
          return of(null);
        }),
      )
      .subscribe(
        () => this.tokenService.getProfilesIfLoggedIn(),
        () => {
          this.tokenStorage.dropUserToken();
          this.router.navigateByUrl('entry/login');
        },
      );
  }

  private processSelfEnrollment(memberSuiteUserToken: string, selfEnrollmentUrl: string): Observable<boolean> {
    const request = {
      token: memberSuiteUserToken,
      payload: {
        link: selfEnrollmentUrl,
      },
    };

    return this.tokenService.getMembersuiteUserSelfEnrollmentLogin(request).pipe(untilDestroyed(this));
  }
}
